import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

const EMPLOYEE_TYPES = [
  { value: "teacher", label: "Teacher" },
  { value: "question_creater", label: "Question Creator" },
  { value: "question_approver", label: "Question Approver" },
  { value: "student_manager", label: "Student Manager" },
  { value: "test_series_manager", label: "Test Series Manager" },
  { value: "marketing_team", label: "Marketing Team" },
  { value: "superadmin", label: "Superadmin" },
];

export default class AddEmployee extends Component {
  state = {
    name: "",
    email: "",
    mobile: "",
    password: "",
    employee_type: "teacher",
    salary: "",
    status: "active",
    notification: false,
    noticolor: "success",
    message: "",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const payload = {
      name: this.state.name,
      email: this.state.email,
      mobile: this.state.mobile,
      password: this.state.password,
      employee_type: this.state.employee_type,
      salary: this.state.salary,
      status: this.state.status,
    };

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createEmployee, payload)
        .then((resp) => {
          this.setState({
            loading: false,
            notification: true,
            noticolor: "success",
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            loading: false,
            notification: true,
            noticolor: "error",
            message: err?.response?.data?.message || "Failed to create employee.",
          });
        });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/employees" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Create Employee
              </MDTypography>
            </MDBox>
            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container sm={12} spacing={2}>
                  <Grid item sm={6}>
                    <InputLabel>Name</InputLabel>
                    <TextField
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Email</InputLabel>
                    <TextField
                      type="email"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Mobile</InputLabel>
                    <TextField
                      type="text"
                      name="mobile"
                      value={this.state.mobile}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      inputProps={{ maxLength: 10 }}
                      required
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Password</InputLabel>
                    <TextField
                      type="text"
                      name="password"
                      value={this.state.password}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Employee Type</InputLabel>
                    <Select
                      value={this.state.employee_type}
                      onChange={(e) => this.setState({ employee_type: e.target.value })}
                      style={{ width: "100%", height: "45px" }}
                    >
                      {EMPLOYEE_TYPES.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Salary</InputLabel>
                    <TextField
                      type="number"
                      name="salary"
                      value={this.state.salary}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      style={{ width: "100%", height: "45px" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>
            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
